const initRegionsAndRolesV2 = () => {
  const module = document.querySelector('.region-and-role-v2');

  if (!module) {
    return;
  }

  const regionSelect = module.querySelector('.region-and-role-v2__region-select');
  const areaSelects = module.querySelectorAll('.region-and-role-v2__area-select');
  const roleSelects = module.querySelectorAll('.region-and-role-v2__role-select');
  const areaPlaceholder = module.querySelector('.region-and-role-v2__area-placeholder');
  const rolePlaceholder = module.querySelector('.region-and-role-v2__role-placeholder');
  const languageButtons = module.querySelectorAll('.region-and-role-v2__language');
  const continueButton = module.querySelector('.region-and-role-v2__continue-button');
  const viewAllLink = module.querySelector('.region-and-role-v2__view-all-link');
  const allPlansButton = document.querySelector('.all-learning-plans-modal__activate');

  if (!regionSelect) {
    return;
  }

  let selectedRegionKey = null;
  let selectedArea = null;
  let selectedRole = null;

  const STORAGE_KEY = 'selectedRegionKey';

  const setCookie = (name, value, days = 365) => {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
  };

  const getCookie = (name) => {
    const escapedName = name.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    const match = document.cookie.match(new RegExp(`(?:^|; )${escapedName}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : null;
  };

  const getRegionKeyFromLanguageCookie = () => {
    const path = window.location.pathname;
    const language = getCookie('mc_selected_language_v2');

    const isIndiaPage =
      path === '/region-selection-india/' ||
      path === '/region-selection-india';

    if (isIndiaPage && language === 'en') {
      return 'in';
    }

    if (language === 'pt-br') {
      return 'br';
    }

    if (language === 'zh-hans') {
      return 'cn';
    }

    if (language === 'en') {
      return 'na';
    }

    return null;
  };

  // Shows one select out of a step and hides the rest, falling back to the
  // disabled placeholder when nothing is available for the current selection.
  const showStepSelect = (selects, placeholder, target) => {
    selects.forEach((select) => {
      if (select !== target) {
        select.value = '';
        select.hidden = true;
      }
    });

    if (placeholder) {
      placeholder.hidden = Boolean(target);
    }

    if (target) {
      target.hidden = false;
    }
  };

  const resetContinueButton = () => {
    if (!continueButton) {
      return;
    }

    continueButton.classList.add('disabled');
    continueButton.removeAttribute('href');
  };

  const resetViewAllLink = () => {
    if (viewAllLink) {
      viewAllLink.classList.add('disabled');
      viewAllLink.removeAttribute('href');
    }

    if (allPlansButton) {
      allPlansButton.removeAttribute('href');
    }
  };

  // The "view all" destination is region specific, so it is armed as soon as a
  // region is known and cleared whenever the region is cleared.
  const updateViewAllLink = () => {
    if (!selectedRegionKey) {
      resetViewAllLink();
      return;
    }

    if (!viewAllLink) {
      return;
    }

    const viewAllHref = viewAllLink.getAttribute(`data-href-${selectedRegionKey}`);

    if (!viewAllHref) {
      resetViewAllLink();
      return;
    }

    viewAllLink.setAttribute('href', viewAllHref);
    viewAllLink.classList.remove('disabled');

    if (allPlansButton) {
      allPlansButton.setAttribute('href', viewAllHref);
    }
  };

  const updateContinueButton = () => {
    if (!continueButton) {
      return;
    }

    if (selectedRegionKey && selectedArea && selectedRole && selectedRole !== '#') {
      continueButton.setAttribute('href', selectedRole);
      continueButton.classList.remove('disabled');
      return;
    }

    resetContinueButton();
  };

  // Rebuilds every step from the values the selects currently hold, so the UI is
  // correct whether a value was set by a click or restored by the browser on a
  // back navigation (which never fires a change event).
  const applySelections = () => {
    const regionOption = regionSelect.options[regionSelect.selectedIndex];
    const regionId = regionSelect.value;

    if (regionId === '' || !regionOption) {
      selectedRegionKey = null;
      selectedArea = null;
      selectedRole = null;

      showStepSelect(areaSelects, areaPlaceholder, null);
      showStepSelect(roleSelects, rolePlaceholder, null);
      resetViewAllLink();
      resetContinueButton();
      return;
    }

    selectedRegionKey = regionOption.getAttribute('data-region-key') || null;

    const targetAreaSelect = module.querySelector(`#step-2-${regionId}`);
    const areaValue = targetAreaSelect ? targetAreaSelect.value : '';

    showStepSelect(areaSelects, areaPlaceholder, targetAreaSelect);

    const targetRoleSelect = areaValue === ''
      ? null
      : module.querySelector(`#step-3-${regionId}-${areaValue}`);

    // A restored area with no matching role list would leave the role step
    // empty, so clear the area rather than showing a dead selection.
    if (areaValue !== '' && !targetRoleSelect && targetAreaSelect) {
      targetAreaSelect.value = '';
    }

    // A role step offering a single role is not a choice, so pick it for the
    // visitor and let the continue button arm straight away.
    if (targetRoleSelect && targetRoleSelect.value === '') {
      const roleOptions = Array.from(targetRoleSelect.options)
        .filter((option) => option.value !== '');

      if (roleOptions.length === 1) {
        targetRoleSelect.value = roleOptions[0].value;
      }
    }

    const roleValue = targetRoleSelect ? targetRoleSelect.value : '';

    showStepSelect(roleSelects, rolePlaceholder, targetRoleSelect);

    selectedArea = targetRoleSelect ? areaValue : null;
    selectedRole = roleValue || null;

    updateViewAllLink();
    updateContinueButton();
  };

  // Picking a region starts the following steps over.
  const activateRegionUI = (regionId) => {
    const targetAreaSelect = module.querySelector(`#step-2-${regionId}`);

    if (targetAreaSelect) {
      targetAreaSelect.value = '';
    }

    applySelections();
  };

  languageButtons.forEach((languageButton) => {
    languageButton.addEventListener('click', () => {
      const languageCode = languageButton.getAttribute('data-language');

      if (!languageCode) {
        return;
      }

      setCookie('mc_selected_language_v2', languageCode);

      // The region is derived from the language on the next page, so drop the
      // region saved for the language being left behind.
      sessionStorage.removeItem(STORAGE_KEY);
    });
  });

  regionSelect.addEventListener('change', () => {
    const selectedOption = regionSelect.options[regionSelect.selectedIndex];
    const regionId = regionSelect.value;

    if (!selectedOption || regionId === '') {
      sessionStorage.removeItem(STORAGE_KEY);
      applySelections();
      return;
    }

    const regionKey = selectedOption.getAttribute('data-region-key');

    if (regionKey) {
      sessionStorage.setItem(STORAGE_KEY, regionKey);
    }

    activateRegionUI(regionId);
  });

  areaSelects.forEach((areaSelect) => {
    areaSelect.addEventListener('change', () => {
      const regionId = regionSelect.value;
      const targetRoleSelect = module.querySelector(`#step-3-${regionId}-${areaSelect.value}`);

      // Picking an area starts the role step over.
      if (targetRoleSelect) {
        targetRoleSelect.value = '';
      }

      applySelections();
    });
  });

  roleSelects.forEach((roleSelect) => {
    roleSelect.addEventListener('change', () => {
      applySelections();
    });
  });

  if (continueButton) {
    continueButton.addEventListener('click', (event) => {
      if (continueButton.classList.contains('disabled') || !continueButton.getAttribute('href')) {
        event.preventDefault();
      }
    });
  }

  if (viewAllLink) {
    viewAllLink.addEventListener('click', (event) => {
      if (viewAllLink.classList.contains('disabled') || !viewAllLink.getAttribute('href')) {
        event.preventDefault();
      }
    });
  }

  const savedRegionKey = sessionStorage.getItem(STORAGE_KEY);
  const cookieRegionKey = getRegionKeyFromLanguageCookie();

  // A region the visitor picked themselves wins. Otherwise the language decides
  // the starting region, which is what makes a language switch land on the
  // matching region.
  const initialRegionKey = savedRegionKey || cookieRegionKey;

  if (initialRegionKey) {
    const matchingOption = regionSelect.querySelector(`option[data-region-key="${initialRegionKey}"]`);

    if (matchingOption && regionSelect.value !== matchingOption.value) {
      // The stored region wins over a restored one, and starts the steps over.
      regionSelect.value = matchingOption.value;
      activateRegionUI(matchingOption.value);
    }
  }

  applySelections();

  // Back navigations restore the select values without firing change events,
  // and pageshow runs after that restore for both fresh loads and the bfcache.
  window.addEventListener('pageshow', () => {
    applySelections();
  });
};

export default initRegionsAndRolesV2;
